import axios from "axios";
import alert from "@/plugins/AlertMessages.js";

export default {
  // Config Actions -------------------------------------------------------------------------------
  getConfig({ dispatch, commit }) {
    axios
      .get("Client/Config")
      .then((res) => {
        commit("setConfig", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Banners Actions -------------------------------------------------------------------------------
  getCustomerBanners({ dispatch, commit }) {
    axios
      .get("client/Banner/Customer")
      .then((res) => {
        commit("setCustomerBanners", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getHonorBanners({ dispatch, commit }, data) {
    axios
      .get("client/Banner/Honor?PageSize=" + data)
      .then((res) => {
        commit("setHonorBanners", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Team Actions -------------------------------------------------------------------------------

  getTeam({ dispatch, commit }) {
    axios
      .get("Client/Team")
      .then((res) => {
        commit("setTeam", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Demo Request -------------------------------------------------------------------------------
  demoRequest({ dispatch, commit }, data) {
    axios
      .post("Client/DemoRequest", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.demoRequestSent,
          },
          { root: true }
        );
        commit("setPostCheck", true, { root: true });
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  // Sliders Actions -------------------------------------------------------------------------------
  getSliders({ dispatch, commit }) {
    axios
      .get("client/Slider")
      .then((res) => {
        commit("setSliders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Services Actions -------------------------------------------------------------------------------
  getServices({ dispatch, commit }) {
    axios
      .get("Client/Services")
      .then((res) => {
        commit("setServices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServicesById({ dispatch, commit }, data) {
    axios
      .get("Client/Services/" + data)
      .then((res) => {
        commit("setServicesById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Tutorials Actions -------------------------------------------------------------------------------
  getTutorials({ dispatch, commit }) {
    axios
      .get("client/Tutorial")
      .then((res) => {
        commit("setTutorials", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTutorialHome({ dispatch, commit }) {
    axios
      .get("client/Widget/11")
      .then((res) => {
        commit("setTutorialHome", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTutorialsPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/Tutorial?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setTutorialsPage", res.data.data);
        commit("setTutorialsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadBtn", false);
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getTutorialById({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Tutorial/" + data)
      .then((res) => {
        commit("setTutorial", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },

  // Products Actions -------------------------------------------------------------------------------
  getProducts({ dispatch, commit }) {
    axios
      .get("client/Product")
      .then((res) => {
        commit("setProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductsHome({ dispatch, commit }) {
    axios
      .get("client/Widget/2")
      .then((res) => {
        commit("setProductsHome", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProductsPage({ dispatch, commit }, data) {
    axios
      .get(
        "client/Product?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setProductsPage", res.data.data);
        commit("setProductsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadBtn", false);
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },

  getProductById({ dispatch, commit }, data) {
    axios
      .get("client/Product/" + data)
      .then((res) => {
        commit("setProduct", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRelatedProducts({ dispatch, commit }, data) {
    axios
      .get("client/Product?pageSize=5&pageNumber=1&categoryId=" + data)
      .then((res) => {
        commit("setRelatedProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Blog Actions -------------------------------------------------------------------------------
  getBlogs({ dispatch, commit }) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Blog")
      .then((res) => {
        commit("setBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getRelatedBlogs({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Blog?categoryId=" + data)
      .then((res) => {
        commit("setRelatedBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getBlogHome({ dispatch, commit }) {
    axios
      .get("client/Widget/1")
      .then((res) => {
        commit("setBlogHome", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getBlogsPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/Blog?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setBlogsPage", res.data.data);
        commit("setBlogsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadBtn", false);
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getBlogById({ dispatch, commit }, data) {
    axios
      .get("client/Blog/" + data)
      .then((res) => {
        commit("setBlog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Gallery Actions -------------------------------------------------------------------------------
  getImages({ dispatch, commit }) {
    axios
      .get("client/ImageGallery")
      .then((res) => {
        commit("setGalleries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getImagesPage({ dispatch, commit }, data) {
    axios
      .get(
        "client/ImageGallery?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setGalleryPage", res.data.data);
        commit("setGalleryPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getImageById({ dispatch, commit }, data) {
    axios
      .get("client/ImageGallery/" + data)
      .then((res) => {
        commit("setGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getVideos({ dispatch, commit }) {
    axios
      .get("client/MovieGallery")
      .then((res) => {
        commit("setGalleries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getVideosPage({ dispatch, commit }, data) {
    axios
      .get(
        "client/MovieGallery?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setGalleryPage", res.data.data);
        commit("setGalleryPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getVideoById({ dispatch, commit }, data) {
    axios
      .get("client/MovieGallery/" + data)
      .then((res) => {
        commit("setGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getGalleryListById({ dispatch, commit }, data) {
    axios
      .get("client/GalleryAlbum/" + data)
      .then((res) => {
        commit("setGalleryList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSounds({ dispatch, commit }) {
    axios
      .get("client/SoundGallery")
      .then((res) => {
        commit("setGalleries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSoundsPage({ dispatch, commit }, data) {
    axios
      .get(
        "client/SoundGallery?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setGalleryPage", res.data.data);
        commit("setGalleryPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSoundById({ dispatch, commit }, data) {
    axios
      .get("client/SoundGallery/" + data)
      .then((res) => {
        commit("setGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Categories Actions -------------------------------------------------------------------------------
  getCategories({ dispatch, commit }, data) {
    axios
      .get("client/Category/GetTreeJson?groupId=" + data)
      .then((res) => {
        commit("setCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCategory({ dispatch, commit }, data) {
    axios
      .get("client/Category?groupId=" + data)
      .then((res) => {
        commit("setCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMenus({ dispatch, commit }) {
    axios
      .get("Client/Menu")
      .then((res) => {
        commit("setMenus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Socials -------------------------------------------------------------------------------------------
  getSocials({ dispatch, commit }) {
    axios
      .get("Client/SocialNetwork")
      .then((res) => {
        commit("setSocials", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // CoOperation Actions -------------------------------------------------------------------------------
  getCities({ dispatch, commit }) {
    axios
      .get("Client/Province")
      .then((res) => {
        commit("setCities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getStates({ dispatch, commit }, data) {
    axios
      .get("Client/Province/" + data)
      .then((res) => {
        commit("setStates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getActivityField({ dispatch, commit }) {
    axios
      .get("Client/ActivityField")
      .then((res) => {
        commit("setActivityField", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Comments Actions -------------------------------------------------------------------------------
  getGalleryComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetGalleryCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
        commit("setCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  getProductComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetProductCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
        commit("setCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  getTutorialComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetTutorialCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
        commit("setCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  getBlogComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetPostCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
        commit("setCommentsLength", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  sendCommentImageGallery({ dispatch, commit }, data) {
    axios
      .post("client/ImageGallery", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
          },
          { root: true }
        );
        commit("setPostCheck", true, { root: true });
        setTimeout(() => {
          commit("setPostCheck", false, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentSoundGallery({ dispatch, commit }, data) {
    axios
      .post("client/SoundGallery", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
          },
          { root: true }
        );
        commit("setPostCheck", true, { root: true });
        setTimeout(() => {
          commit("setPostCheck", false, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentMovieGallery({ dispatch, commit }, data) {
    axios
      .post("client/MovieGallery", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
          },
          { root: true }
        );
        commit("setPostCheck", true, { root: true });
        setTimeout(() => {
          commit("setPostCheck", false, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentProducts({ dispatch, commit }, data) {
    axios
      .post("client/Product", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
          },
          { root: true }
        );
        commit("setPostCheck", true, { root: true });
        setTimeout(() => {
          commit("setPostCheck", false, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentTutorials({ dispatch, commit }, data) {
    axios
      .post("client/Tutorial", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
          },
          { root: true }
        );
        commit("setPostCheck", true, { root: true });
        setTimeout(() => {
          commit("setPostCheck", false, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentBlogs({ dispatch, commit }, data) {
    axios
      .post("client/Blog", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
          },
          { root: true }
        );
        commit("setPostCheck", true, { root: true });
        setTimeout(() => {
          commit("setPostCheck", false, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  // Poster Actions --------------------------------------------
  getPosters({ dispatch, commit }) {
    axios
      .get("Client/Poster")
      .then((res) => {
        commit("setPosters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDynamicPageContent({ dispatch, commit }, data) {
    axios
      .get("client/Page?name=" + data)
      .then((res) => {
        commit("setDynamicPageContent", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAboutPageContent({ dispatch, commit }) {
    axios
      .get("client/Page?name=AboutUs")
      .then((res) => {
        commit("setAboutPage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getContactPageContent({ dispatch, commit }) {
    axios
      .get("client/Page?name=ContactUs")
      .then((res) => {
        commit("setContactPage", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Support Actions --------------------------------------------
  getSupport({ dispatch, commit }) {
    axios
      .get("Client/Support")
      .then((res) => {
        commit("setSupport", res.data.data[0]);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Rules Actions --------------------------------------------
  getRules({ dispatch, commit }) {
    axios
      .get("client/Page?name=rules")
      .then((res) => {
        commit("setRules", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Method Of Introductions --------------------------------------------
  getMethodOfIntroductions({ dispatch, commit }) {
    axios
      .get("Client/MethodOfIntroduction")
      .then((res) => {
        commit("setMethodOfIntroductions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Support Actions --------------------------------------------
  getCustomerOpinion({ dispatch, commit }) {
    axios
      .get("Client/CustomerOpinion")
      .then((res) => {
        commit("setCustomerOpinion", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // NewsLetter Actions -------------------------------------------------------------------------------
  sendNewsLetter({ dispatch }, data) {
    axios
      .post("Client/Subscriber", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // ContactMessages Actions -----------------------------
  sendMessage({ dispatch, commit }, data) {
    axios
      .post("Client/ContactUs", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
};
